
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.pie-chart-wrapper {
  position: relative;
}
.slice-info {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  height: auto;
  width: 7rem;
  text-align: center;
  text-transform: uppercase;
}
@media (min-width: 768px) {
  .slice-info {
    position: absolute;
  }
  .slice-info {
    z-index: 50;
  }
}
.slice-info-count {
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  color: var(--blue-responsible-main);
}
.slice-info-label {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}
.slice-info-name {
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}
@media screen and (min-width: 768px){
  .slice-info{
    top:48%;
    left:50%;
    right:50%;
    transform:translate(-50%, -50%);
  }
}
.percentage-info {
  position: absolute;
  z-index: 50;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  height: auto;
  width: 7rem;
  text-align: center;
  text-transform: uppercase;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-bold);
  color: var(--neutral-white);
  font-size:40px;
  top:48%;
  left:45%;
  right:45%;
  transform:translate(-50%, -50%);
}
`;